import { useEffect, useState } from "react";
import CheckBox from "../../../../../../Button/CheckBox";
import DefaultModalLayout from "../../../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../../../Users/UserDetail/CommentModal/CommentModal";
import styled from "styled-components";
import sharedefinition_set from "../../../../../../../data_json/sharedefinition_set.json";
import subscription_set from "../../../../../../../data_json/subscription_set.json";
import moment from "moment";
import { OptionType } from "../../../../../../Filters/DropDown";
import {
  getString3ByKey,
  getSubsNameBySubsId3,
} from "../../../../../../../AdminApi/3.0_utils";

interface Props extends DefaultModalCommonProps {
  saveSubsList: (list: OptionType[]) => void;
  selectedList: OptionType[];
}

const activatedSubscription = subscription_set.filter(
  (data) =>
    moment().isSameOrAfter(
      moment(data.SUBS_ADATE).format("YYYY-MM-DD HH:mm")
    ) && data?.SUBS_ACT === "activate"
);

export default function FaqServiceSelectModal({
  closeEvent,
  saveSubsList,
  selectedList,
}: Props) {
  const [selectAll, setSelectAll] = useState(false);
  const [subsId, setSubsId] = useState<OptionType[]>(selectedList);
  const [shareTypeGroup, setShareTypeGroup] = useState<
    [string, OptionType[]][]
  >([]);

  console.log(subsId);

  useEffect(() => {
    const getShareTypeGroup = () => {
      const obj = sharedefinition_set?.reduce((acc: any, cur: any) => {
        const { SHARDEF_TYP } = cur;

        acc[SHARDEF_TYP] = acc[SHARDEF_TYP] ?? [];
        acc[SHARDEF_TYP].push(cur);

        return acc;
      }, {});

      const arrByShareType: [string, any[]][] = Object.entries(obj);
      const list: [string, any[]][] = [];

      arrByShareType?.forEach((el) => {
        const shareType = el[0];
        const shareData = el[1];

        const shareDefIdList = shareData.map((s) => +s.SHARDEF_ID);

        const set = new Set(shareDefIdList);
        const uniqueShareDefIdList = [...set];

        const subsList = uniqueShareDefIdList?.map((shareDefId) =>
          activatedSubscription.filter((s) => s.SHARDEF_ID === shareDefId)
        );

        const sortedSubsList = [...new Set(subsList.flat())]
          ?.sort((a, b) => a.SUBS_ID - b.SUBS_ID)
          ?.map((s) => {
            const subsData = subscription_set?.find(
              (subs) => subs.SUBS_ID === s.SUBS_ID
            );
            const subsName = getString3ByKey(subsData?.SUBS_NM ?? 0);

            return {
              value: `${s.SUBS_ID}`,
              label: `${subsName}`,
            };
          });

        list.push([shareType, sortedSubsList]);
      });

      console.log(list);
      setShareTypeGroup(list);
    };

    getShareTypeGroup();
  }, []);

  return (
    <>
      <DefaultModalLayout
        modalTitle="서비스 선택"
        closeEvent={closeEvent}
        confirmEvent={() => {
          saveSubsList(subsId);
          closeEvent();
        }}
      >
        <CheckList>
          <CheckBox
            label="전체 서비스 선택"
            checked={selectAll}
            onChange={(e: { target: { checked: boolean } }) => {
              const checked = e.target.checked;

              if (checked) {
                const allSubsList = activatedSubscription?.map((s) => {
                  const subsData = subscription_set?.find(
                    (subs) => subs.SUBS_ID === s.SUBS_ID
                  );
                  const subsName = getString3ByKey(subsData?.SUBS_NM ?? 0);

                  return {
                    value: `${s.SUBS_ID}`,
                    label: `${subsName}`,
                  };
                });
                setSubsId(allSubsList);
              } else {
                setSubsId([]);
              }

              setSelectAll(e.target.checked);
            }}
          />

          {shareTypeGroup?.map((s) => {
            const shareType = s[0];
            const subsList = s[1];

            const shareTypeChecked =
              subsId?.length > 0 && subsList?.length > 0
                ? subsList?.every(
                    (subs) =>
                      subsId?.findIndex((s) => s.value === subs.value) >= 0
                  )
                : false;

            return (
              <ShareType>
                <CheckBox
                  label={shareType}
                  checked={shareTypeChecked}
                  isBold
                  onChange={(e: {
                    target: {
                      checked: boolean;
                    };
                  }) => {
                    const checked = e.target.checked;

                    if (checked) {
                      setSubsId((prev) => [...prev, ...subsList]);
                    } else {
                      setSubsId((prev) => [
                        ...prev?.filter((s) => subsList?.indexOf(s) < 0),
                      ]);
                    }
                  }}
                />

                <SubsList>
                  {subsList?.map((subs) => {
                    const subsName = getSubsNameBySubsId3(+subs?.value!);

                    const hasChecked =
                      subsId?.findIndex((s) => s.value === subs?.value) >= 0;

                    return (
                      <CheckBox
                        label={`${subs.value}_${subsName}`}
                        checked={hasChecked}
                        onChange={(e: {
                          target: {
                            checked: boolean;
                          };
                        }) => {
                          const checked = e.target.checked;

                          if (checked) {
                            setSubsId((prev) => [...prev, subs]);
                          } else {
                            setSubsId((prev) => [
                              ...prev?.filter((s) => s !== subs),
                            ]);
                          }
                        }}
                      />
                    );
                  })}
                </SubsList>
              </ShareType>
            );
          })}
        </CheckList>
      </DefaultModalLayout>
    </>
  );
}

const CheckList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 40px;
`;

const ShareType = styled.div``;

const SubsList = styled.div`
  margin-left: 28px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;
